import { Col, Row, Tooltip } from 'antd';
import { lowerCase, startCase } from 'lodash';

import { MilesText, Status } from 'components';

import { Links } from 'links';

import { MatchedBy, ProductLineItemMatch } from 'codegen';
import { TColumn, TFieldProps } from 'types';

export const columns: TColumn<ProductLineItemMatch>[] = [{
  width: 180,
  title: 'Line Item',
  dataIndex: 'lineItem',
  render: (value, record) => {
    if (record.status === ProductLineItemMatch.status.MANUAL_MATCH) {
      return (
        <Tooltip placement='bottomLeft' title={`${value.name} - ${value.sku}`}>
          <p className='truncate'>
            {`${value.name} - ${value.sku}`}
          </p>
        </Tooltip>
      );
    }

    if (record.matchedBy?.type === MatchedBy.type.SKU) {
      return value.sku;
    }

    return (
      <Tooltip placement='bottomLeft' title={value.name}>
        <p className='truncate'>
          {value.name}
        </p>
      </Tooltip>
    );
  },
}, {
  width: 200,
  title: 'Enriched Name',
  dataIndex: 'lineItem.enrichedName',
}, {
  width: 200,
  title: 'Matched By',
  dataIndex: 'matchedByIdentities',
  render: (matchedByIdentities) => {
    if (Array.isArray(matchedByIdentities)) {
      return (
        <Row>
          {matchedByIdentities.map((m) => (
            <Col key={m.type} xs={24}>
              <MilesText>
                {`${m.type} - ${m.value}`}
              </MilesText>
            </Col>
          ))}
        </Row>
      );
    }

    return null;
  },
}, {
  width: 90,
  title: 'Quantity',
  dataIndex: 'quantity',
}, {
  type: TColumn.type.Status,
  width: 130,
  title: 'Status',
  dataIndex: 'status',
}, {
  type: TColumn.type.Percent,
  width: 130,
  title: 'Matching Score',
  dataIndex: 'matchScore',
}, {
  type: TColumn.type.Percent,
  width: 100,
  title: 'OCR Score',
  dataIndex: 'ocrScore',
}, {
  type: TColumn.type.IDRedirect,
  width: 70,
  title: 'Snap ID',
  dataIndex: 'snapId',
  pathname: Links.Snaps,
}, {
  type: TColumn.type.Date,
  width: 160,
  title: 'Created Date (EST)',
  dataIndex: 'createdAt',
}, {
  width: 160,
  title: 'Collector ID',
  dataIndex: 'collectorId',
}, {
  type: TColumn.type.Checkbox,
  width: 100,
  title: 'Processed',
  dataIndex: 'isTransactionCreated',
}];

export const fields = (isAdmin: boolean): TFieldProps[] => [{
  type: TFieldProps.type.DateRangePicker,
  name: 'submittedDates',
  colProps: { xs: 8, xxl: 4 },
  placeholder: 'Match Created Date',
}, {
  type: TFieldProps.type.Select,
  name: 'matchStatuses',
  mode: 'multiple',
  options: Object.values(ProductLineItemMatch.status).map((st) => ({ label: startCase(lowerCase(st)), value: st })),
  colProps: { xs: 8, xxl: 3 },
  placeholder: 'Match Status',
  tagRender: ({ value }) => <Status key={value} status={value} />,
  maxTagCount: 'responsive',
}, ...(isAdmin
  ? [{
    type: TFieldProps.type.Text,
    name: 'collectorNumber',
    colProps: { xs: 4, xxl: 3 },
    placeholder: 'Collector Number',
  }]
  : []
), {
  type: TFieldProps.type.Text,
  name: 'collectorId',
  colProps: { xs: !isAdmin ? 8 : 4, xxl: 3 },
  placeholder: 'Collector ID',
}];
